<div class="content-page">
  <div class="container container-sm">
    <div class="page-header">
      <span class="section-tag">Legal</span>
      <h1 class="page-title">Privacy Policy</h1>
      <p class="page-subtitle">Last updated: January 2026</p>
    </div>

    <div class="content-block">
      <h2>1. Information We Collect</h2>
      <p>We collect information you provide directly to us, such as when you create an account, submit URLs, or contact us for support. This may include your name, email address, phone number, and payment information.</p>
    </div>

    <div class="content-block">
      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul class="content-list">
        <li>Provide, maintain, and improve our services</li>
        <li>Process transactions and send related information</li>
        <li>Send you technical notices, updates, and support messages</li>
        <li>Respond to your comments, questions, and customer service requests</li>
      </ul>
    </div>

    <div class="content-block">
      <h2>3. Information Sharing</h2>
      <p>We do not sell, trade, or otherwise transfer your personally identifiable information to third parties. This does not include trusted third parties who assist us in operating our website, conducting our business, or serving you, as long as those parties agree to keep this information confidential.</p>
    </div>

    <div class="content-block">
      <h2>4. Data Security</h2>
      <p>We implement a variety of security measures to maintain the safety of your personal information. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems.</p>
    </div>

    <div class="content-block">
      <h2>5. Cookies</h2>
      <p>We use cookies to understand and save your preferences for future visits and compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.</p>
    </div>

    <div class="content-block">
      <h2>6. Changes to This Policy</h2>
      <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last updated" date.</p>
    </div>

    <div class="content-block">
      <h2>7. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@quickindexingtool.com">support&#64;quickindexingtool.com</a>.</p>
    </div>
  </div>
</div>
